import { WEEKDAYS_ARRAY } from "@/helpers/constants/app";
import store from "@/store";
import { isLoggedIn } from "@/helpers/js/user";

export function getConfigWeekDay() {
    if (!isLoggedIn()) return "Monday";
    return store.state.configurations?.StartDayOfWeek || "Monday";
}

export async function getCurrentWeekDate() {
    if (!isLoggedIn()) return;

    const configuredDay = getConfigWeekDay();

    const targetDay = WEEKDAYS_ARRAY.indexOf(configuredDay);
    if (targetDay === -1) return null;

    const current = new Date();
    const diff = (current.getDay() + 7 - targetDay) % 7;
    current.setDate(current.getDate() - diff);
    current.setHours(0, 0, 0, 0);

    const yyyy = current.getFullYear();
    const mm = String(current.getMonth() + 1).padStart(2, "0");
    const dd = String(current.getDate()).padStart(2, "0");
    return `${yyyy}/${mm}/${dd}`;
}
